import React, { useEffect, useState } from "react";
import "../styles/App.css"; // Import global styles
import AdminLogin from "../components/AdminSignin";
import AdminCard from "../components/AdminCard";
import AdminActionsContainer from "../components/AdminActionsContainer";
import { useNavigate } from "react-router-dom";
import { SERVER_URL } from "../config";

interface Admin {
  id: string;
  firstName: string;
  lastName: string;
  jobTitle: string;
  phone: string;
  createdAt: string;
  updatedAt: string;
  userId: string;
  email: string;
  role: string;
  user: {
    email: string;
    createdAt: string;
  };
}

const AdminPage: React.FC = () => {
  const [adminData, setAdminData] = useState<Admin | null>(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAdminProfile = async () => {
      try {
        const response = await fetch(`${SERVER_URL}/api/admin/profile`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        const data = await response.json();

        if (response.ok) {
          setAdminData(data);
          navigate("/admin/dashboard");
        } else {
          setError(data.error || "Failed to fetch admin profile.");
        }
      } catch (err) {
        setError("An error occurred while fetching the admin profile.");
      } finally {
        setLoading(false);
      }
    };

    fetchAdminProfile();
  }, []);

  if (loading) return <p>Loading admin profile...</p>;

  if (!adminData)
    return (
      <div>
        <h1>No Admin found</h1>
        <AdminLogin />
      </div>
    );

  return (
    <div className="Admin-Container">
      <AdminCard admin={adminData} />
      <AdminActionsContainer
        admin={
          adminData
            ? {
                ...adminData,
                user: {
                  ...adminData.user,
                  role: "ADMIN",
                },
              }
            : undefined
        }
      />
    </div>
  );
};

export default AdminPage;
